import CustomModal from 'components/mocules/CustomModal';
import useAffiliateLinkClaim from 'hooks/useAffiliateLinkClaim';

/**
 * Gắn khách cho CTV sau khi đăng nhập (BV-2399) và hiện popup kết quả: đã liên kết, hoặc đã thuộc
 * CTV khác (liên hệ CSKH để chuyển). Đặt trong AuthProvider.
 */
export default function AffiliateLinkClaim() {
  const [popup, closePopup] = useAffiliateLinkClaim();
  if (!popup) return null;
  return (
    <CustomModal
      visible
      icon={popup.warning}
      onClose={closePopup}
      onClickOk={closePopup}
      title={popup.title}
      content={popup.content}
      showClose={false}
      btnOk="Đã hiểu"
    />
  );
}
